import Sort from '../other/Sort'

export const sort_mix = {
  components: { Sort },
  data() {
    return {
      sortDirection: 'desc',
      sortBy: ''
    }
  },
  computed: {
    sortedItems() {
      if (this.sortBy === 'day') {
        return _.orderBy(this.items, [function (a) {
          let time = a.time ? a.time : "00:00:00"
          let m = moment(a.day + ' ' + time , 'ddd dddd');
          return m;
        }, 'time'], this.sortDirection)
        
      } else {
        return _.orderBy(this.items, this.sortBy, this.sortDirection)
      }      
    },
    direction() {
      return this.sortDirection === 'asc' ? '↓' : '↑'
    }
  },
  methods: {
    sort(key) {
      this.sortBy = key
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      this.saveParams()
    },
    saveParams() {
      let sortData = {
        sortBy: this.sortBy,
        sortDirection: this.sortDirection,
        sortTypes: Object.keys(this.sortTypes).join()
      }
      localStorage.setItem('sortData', JSON.stringify(sortData))
    }
  },
  mounted() {
    if (localStorage.sortData) {
      let data = JSON.parse(localStorage.sortData)
      let currentTypes = Object.keys(this.sortTypes).join()
      
      if (data.sortTypes === currentTypes) {
        this.sortBy = data.sortBy
        this.sortDirection = data.sortDirection
      }      
    }
  }
};